import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { ConnectConversations } from 'apps/home/connect/conversations/index';
import { ConnectOrganisations } from 'apps/home/connect/organisations/index';

const viewsMap = {
  conversations: ConnectConversations,
  organisations: ConnectOrganisations,
};

@withNamespaces()
@observer
class ConnectSpace extends React.Component {
  UNSAFE_componentWillMount() {
    const { route, routerStore } = this.props;
    if (route.name === 'home.connect') {
      routerStore.router.navigate('home.connect.members');
    }
  }

  render() {
    const View = this.props.componentFromRoute();
    return <View params={this.props.route.params} />;
  }
}

ConnectSpace.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const ConnectRouter = routeNode(
  'home.connect',
  viewsMap,
  FourOhFour,
)(ConnectSpace);
